import { useRef, useCallback } from 'react';
import '../useEventListener/c3560e46908f7d0b3c87fb45bf97bba8a41c7f11b9b9cc6ce5177ecd19c06ee3.cfe-internal.js';
import useEventListener from '../useEventListener/d298373edbbbe27e03edc667e68a196078d5abecbf27f9b61af0b7bc7dd7b6a0.cfe-internal.js';

/* eslint-disable consistent-return */

/**
 * Listens for `click` event. The returned function is used to ignore the given `click` event.
 * @param onClickOutside - An observer that is called when an outside click occurs.
 * @param options.disabled - Indicates if the hook is disabled (i.e. won't call the observer)
 * @returns A function that, when called, ignores the current outside click if one exists.
 */
function useClickOutsidePortals(onClickOutside) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var wasClickedInside = useRef(false);
  var handleClick = function handleClick(e) {
    if (!wasClickedInside.current) {
      onClickOutside(e);
    }
    // should reset clicked state after each click
    wasClickedInside.current = false;
  };
  useEventListener(document, 'mouseup', handleClick, {
    isDisabled: disabled
  });
  var preventClickOutside = useCallback(function () {
    wasClickedInside.current = true;
  }, []);
  return preventClickOutside;
}

export { useClickOutsidePortals as default };
